import { useMemo } from 'react'
import type { AgeData } from '../OverviewTab.types'

export const useBuildingAge = (building: any): AgeData => {
  const currentYear = new Date().getFullYear()

  return useMemo(() => {
    if (building.building_year) {
      return {
        age: currentYear - building.building_year,
        year: building.building_year,
        isEstimate: false,
      }
    }

    if (building.building_period) {
      const period = building.building_period

      // Handle "0-1919" period FIRST
      if (period === '0-1919') {
        const estimatedYear = 1900
        return {
          age: currentYear - estimatedYear,
          year: estimatedYear,
          isEstimate: true,
          period: period,
        }
      }

      // Handle "2015-x" (ongoing construction)
      if (period.includes('-x')) {
        const startYear = parseInt(period.split('-')[0])
        return {
          age: currentYear - startYear,
          year: startYear,
          isEstimate: true,
          period: period,
        }
      }

      // Handle range periods like "1971-1980"
      const match = period.match(/(\d{4})-(\d{4})/)
      if (match) {
        const startYear = parseInt(match[1])
        const endYear = parseInt(match[2])
        const midYear = Math.round((startYear + endYear) / 2)
        return {
          age: currentYear - midYear,
          year: midYear,
          isEstimate: true,
          period: period,
        }
      }
    }

    return { age: 0, year: null, isEstimate: false }
  }, [building.building_year, building.building_period, currentYear])
}
